module.exports = __webpack_public_path__ + "static/media/BookmarkApp.83ba56b4.png";